/* eslint-disable react/display-name */
import React from 'react';
import { ToastContainer } from 'react-toastify';

// autoClose={2000}

export default function () {
  return <ToastContainer autoClose={2000} hideProgressBar newestOnTop />;
}
